import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteEntry } from 'store/data/entries';

export function useDeleteEntry(): Operation {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.DELETE_ENTRY);

	function handler() {
		dispatch(deleteEntry());
	}

	return [{ loading, error }, handler];
}
